import {UrlCreator, formDataCreator} from "../../../utils/requestCreator";
import {SUB_EVENTS_OBJECT} from '../../../config/constants';

export const SUBJECT_DATA_IS_LOADING = 'SUBJECT_DATA_IS_LOADING';
export const SUBJECT_DATA_IS_FAILED = 'SUBJECT_DATA_IS_FAILED';
export const SUBJECT_DATA_IS_SUCCESS = 'SUBJECT_DATA_IS_SUCCESS';

function dataIsLoading() {
    return {
        type: SUBJECT_DATA_IS_LOADING
    }
}

function dataIsSuccess(data) {
    return {
        type: SUBJECT_DATA_IS_SUCCESS,
        payload: data
    }
}

function dataIsFailed() {
    return {
        type: SUBJECT_DATA_IS_FAILED
    }
}

export function fetchSubjectData() {
    const URL = UrlCreator();
    return (dispatch) => {
        let initialKey = localStorage.token;
        const requestData = formDataCreator(null, SUB_EVENTS_OBJECT, {}, [], initialKey, null, null, "daynum" );
        dispatch(dataIsLoading());
        return fetch(URL, {
            method: 'POST',
            body: requestData
        }).then((response) => {
            if(response.status !== 200) {
                throw Error(response.statusText)
            }

            dispatch(dataIsLoading());
            return response.json();
        }).then((data) => {
            if (data.status !== '0') {
                dispatch(dataIsFailed());
                return;
            }

            dispatch(dataIsSuccess(data))
        }).catch(e => console.error(e))
    }
}
